import React from 'react';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

// TODO: Going to need to pull this apart and determine where/how it's being used so it can be safely refactored
const PrivateRoute = ({
  component: Component,
  hasToken,
  hasProfile,
  consent,
  ...rest
}) => {
  let render = props => <Component {...props} {...rest} />;

  if (
    !hasProfile &&
    (rest.path !== '/profile' && rest.path !== '/onboarding/profiles')
  ) {
    render = props => (
      <Redirect
        to={{ pathname: '/profile', state: { from: props.location } }}
      />
    );
  }

  if (!hasToken) {
    render = props => (
      <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    );
  }

  // currently this is not possible, however we will want this moving forward
  if (hasToken && !consent && rest.path !== '/onboarding/profiles') {
    render = props => (
      <Redirect
        to={{
          pathname: '/consent-refused',
          state: { from: props.location }
        }}
      />
    );
  }

  return <Route {...rest} render={render} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.object]).isRequired,
  hasToken: PropTypes.bool.isRequired,
  hasProfile: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired,
  consent: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  const { consent } = state.auth.token
    ? jwtDecode(state.auth.token)
    : { consent: false };

  return {
    hasToken: state.auth.hasToken,
    hasProfile: state.auth.hasProfile,
    hasProfiles: state.auth.hasProfiles,
    hasBabies: state.auth.hasBabies,
    consent
  };
}

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js